import {MenuOption} from "@lexical/react/LexicalTypeaheadMenuPlugin"
import {EntityType} from "../../../../gd/const/item"

export class MentionOption extends MenuOption {
    id      : ID
    name    : string
    type    : EntityType
    data    : any

    constructor(data: {
        id      : ID
        name    : string
        type    : EntityType
        data    : any
    }) {
        super(data.id)
        this.id     = data.id
        this.name   = data.name
        this.type   = data.type
        this.data   = data.data
    }
}